import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import otterize from '../assets/imgs/otterize/otterize-cube-logo-img.png'; 
import arrows from '../assets/imgs/arrows/cover-img.png'; 
import navina from '../assets/imgs/navina/navina_web_animations_cover.jpg'; 
import navina_quality from '../assets/imgs/navina/navina _quality _video _cover.png'; 
import navina2024 from '../assets/imgs/navina/navina-videos-cover-img.png'; 
import vayyar from '../assets/imgs/vayyar/cover-img.png'; 
import spark from '../assets/imgs/spark/cover-img.png'; 
import astrix from '../assets/imgs/astrix/cover-img.png'; 
import komodor from '../assets/imgs/komodor/cover-img.png'; 
import clariter from '../assets/imgs/clariter/clariter00.png'; 
import prodop from '../assets/imgs/prodop/cover-prodop.png'; 
import geoxITC from '../assets/imgs/geoxITC/cover-img.jpg'; 
import rtmiCapital from '../assets/imgs/rtmicapital/cover.png'; 




const HomePage = ({}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  return (
    <div className='bg-light pb-5 m-0'>
      <div className='header-height'></div>
      <div className='row px-4 m-0'>
        <div className='col-2'></div>
        <div className='col-sm col-xs-12'>
          <div className='pb-4'>
            <p className='fs-4 fw-normal'>
              Bring brands, products, and stories to life through art, design, and technology. With over a decade of experience and recognition from leading tech companies, I specialize in 3D animation, interactive development, and virtual reality to craft immersive digital experiences.
            </p>
          </div>

          <div className='row'>
              <div className='col-md-6 col-xs-12 p-2 my-4 '>
            <Link to="/prodop">
              <div className='image-container'>
                <img className='img-fluid img-square' src={prodop} alt='profop production management platform' />
              </div>
              <div className='my-2 text-dark'>
                <h6 className='fs-18 fw-normal text-capitalize'>prodop production management</h6>
              </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
            <Link to="/navina-risk">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={navina2024} alt='otterize-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Navina: AI-powered risk adjustment</h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
              <Link to="/rtmi-capital">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={rtmiCapital} alt='otterize-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>RTMI Capital </h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
              <Link to="/navina">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={navina} alt='otterize-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Navina Web Animations</h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
              <Link to="/otterize">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={otterize} alt='otterize-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Otterize Explainer</h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
              <Link to="/arrows">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={arrows} alt='otterize-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Arrows</h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
              <Link to="/geoxITC">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={geoxITC} alt='otterize-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Geox ITC 2024</h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 pointer'>
              <Link to="/vayyar">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={vayyar} alt='vayyar-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Vayyar App Animations</h6>
                </div>
              </Link>
            </div>
            <div className='col-md-6 col-xs-12 p-2 my-4 '>
              <Link to="/spark">
                <div className='image-container'>
                  <img className='img-fluid img-square pointer' src={spark} alt='spark-cover' />
                </div>
                <div className='my-2 text-dark'>
                  <h6 className='fs-18 fw-normal text-capitalize pointer'>Spark Explained</h6>
                </div>
              </Link>
            </div>


          </div>
        </div>
      </div>
      
      <div className='header-height'></div>

    </div>
  );
};

export default HomePage;
